import { brandBorder, brandBackground, brandText, } from '@guardian/src-foundations/palette';
export const footerBrand = {
    footer: {
        border: brandBorder.primary,
        background: brandBackground.primary,
        text: brandText.primary,
        anchor: brandText.anchorPrimary,
        anchorHover: brandText.anchorPrimaryHover,
    },
};
//# sourceMappingURL=footer.js.map
